import React, { useState } from 'react';
import { StyleSheet, Image, TouchableOpacity, View, ActivityIndicator } from 'react-native';
import Viewer from 'react-viewer';
import theme from '../../constants/theme.style.js';

const styles = StyleSheet.create({
  imageContainer: {
    width: '100%',
    height: '100%',
  },
  previewContainer: {
    width: theme.ICON_WIDTH * 3,
    height: theme.ICON_WIDTH * 4,
    justifyContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'absolute',
    bottom: 40,
    left: 15,
    borderRadius: 30,
  },
  loadingSpinner: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.GREY_LIGHT_COLOR,
    borderRadius: 30,
    width: theme.ICON_WIDTH * 3,
    height: theme.ICON_WIDTH * 3,
    position: 'absolute',
    bottom: -10,
  },
  previewImage: {
    width: theme.ICON_WIDTH * 3,
    height: theme.ICON_WIDTH * 3,
    borderRadius: 30,
  },
  container: {
    flex: 1,
  },
  closeButton: {
    backgroundColor: 'transparent',
    padding: 20,
    alignSelf: 'flex-end',
    marginTop: 0,
    position: 'absolute',
    top: 50,
    zIndex: 100,
    elevation: 2,
  },
  openButton: {
    padding: 10,
    marginTop: '1em',
    elevation: 2,
  },
});

export const MessageDetailAttachment = ({ images }) => {
  const [visible, setVisible] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const imagesArr = [];
  images.forEach((image) => {
    imagesArr.push({ src: image.source });
  });

  const previewImage = (
    <Image
      style={styles.previewImage}
      source={{ uri: imagesArr[0].src }}
      onLoad={() => setImageLoaded(true)}
      testID="preview-image"
    />
  );

  return (
    <View style={styles.container}>
      <Viewer
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        images={imagesArr}
        attribute={false}
        zoomSpeed={0.4}
        onMaskClick={() => setVisible(false)}
        testID="image"
      />
      <View style={styles.previewContainer}>
        {!imageLoaded && (
          <ActivityIndicator
            style={styles.loadingSpinner}
            size="large"
            color={theme.GREEN_WARM_COLOR}
            testID="spinner"
          />
        )}
        <TouchableOpacity
          style={styles.openButton}
          onPress={() => {
            setVisible(true);
          }}
          testID="image-touchable"
        >
          {previewImage}
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default MessageDetailAttachment;
